package anjuros.development.sections

import androidx.compose.runtime.Composable
import anjuros.development.components.FacilityCard
import anjuros.development.components.SectionTitle
import anjuros.development.modules.Facilities
import anjuros.development.modules.Section
import anjuros.development.util.Constants
import anjuros.development.util.SmallSectionWidthStyle
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun FacilitySection(){
    Box(
        modifier = Modifier
            .id(Section.Facilities.id)
            .padding(topBottom = 70.px)
            .maxWidth(Constants.SECTION_WIDTH.px),
        contentAlignment = Alignment.Center
    ) {
        FacilityContent()
    }
}

@Composable
fun FacilityContent(){


    Column(
        modifier = Modifier.fillMaxWidth(90.percent)
        ,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        SectionTitle(
            modifier = SmallSectionWidthStyle.toModifier()
                .margin( bottom = 50.px),
            section = Section.Facilities,
            alignment = Alignment.CenterHorizontally
        )

        SimpleGrid(numColumns = numColumns(base = 2, md = 2, lg = 3)) {
            Facilities.entries.forEach { facility ->

                FacilityCard(facility)
            }
        }
    }
}